const getPieOptions = (style) => {
    if (style === 2) {
        const chartOption = {
            textStyle: {
                fontFamily: 'font-normal',
                fontSize: 12
            },
            legend: {
                orient: 'horizontal',
                bottom: '10%',
                width: '100%',
                align: 'auto',
                itemGap: 30,
                itemWidth: 10,
                itemHeight: 10,
                selectedMode: true
            },
            series: [
                {
                    type: 'pie',
                    center: ['50%', '40%'],
                    radius: ['40%', '57%'],
                    avoidLabelOverlap: false,
                    hoverAnimation: true,
                    legendHoverLink: true,
                    label: {
                        show: false,
                        position: 'center',
                        formatter: function(param) {
                            return `{a|${parseFloat(param.value).toString() == 'NaN'
                                ? '0.0'
                                : parseFloat(param.value).toFixed(1)
                                }%}\n{b|${param.name}}`;
                        },
                        emphasis: {
                            show: true,
                            textStyle: {
                                fontSize: '30',
                                fontWeight: 'bold'
                            }
                        },
                        align: 'center',
                        rich: {
                            a: {
                                color: 'rgb(40,40,40)',
                                fontSize: 20,
                                fontFamily: 'font-bold'
                            },
                            b: {
                                fontSize: 12,
                                color: 'rgb(80,80,80)',
                                fontFamily: 'font-normal'
                            }
                        }
                    }
                }
            ]
        };
        return chartOption;
    } else {
        const chartOption = {
            textStyle: {
                fontFamily: 'font-normal',
                fontSize: 12
            },
            legend: {
                orient: 'horizontal',
                bottom: '10%',
                width: '100%',
                align: 'auto',
                itemGap: 30,
                itemWidth: 10,
                itemHeight: 10,
                selectedMode: false
            },
            series: [
                {
                    type: 'pie',
                    center: ['50%', '40%'],
                    radius: ['40%', '57%'],
                    avoidLabelOverlap: false,
                    legendHoverLink: false,
                    hoverOffset: 0,
                    cursor: 'default',
                    label: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false
                        }
                    }
                }
            ]
        };
        return chartOption;
    }
};

export default getPieOptions;
